import { JoeDns, Schema } from "../../../../../@types";
import Name from "../../../../../../search/schema/components/Name";
import { enums } from "../../../../../../../shim/jsbridge";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

export const dns: Schema<JoeDns> = {
  fields: [
    {
      name: "timestamp",
      displayTitle: "Timestamp",
      sortable: true,
      component: d => <>{d.timestamp}</>
    },
    {
      name: "srcip",
      displayTitle: "Source IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.srcip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "dstip",
      displayTitle: "Destination IP",
      sortable: true,
      component: d => (
        <Name
          data={{
            file_name: d.dstip,
            int_submission_analyzer: URLANALYZER
          }}
        />
      )
    },
    {
      name: "optype",
      displayTitle: "OP type",
      sortable: true,
      component: d => <>{d.optype}</>
    },
    {
      name: "transid",
      displayTitle: "Trans ID",
      sortable: true,
      component: d => <>{d.transid}</>
    },
    {
      name: "name",
      displayTitle: "Name",
      sortable: true,
      component: d => <>{d.name}</>
    },
    {
      name: "additional",
      displayTitle: "Additional",
      sortable: true,
      component: d => <>{d.additional}</>
    }
  ]
};
